import { type Ratio, subtractRatio } from '@taler/domain'

export interface RatioChange {
  readonly direction: -1 | 0 | 1
  /** The change in percentage points, as a ratio (0.06 reads as 6 points). */
  readonly points: Ratio
}

/** Savings rate against the previous window, in points rather than as a percent of a percent. */
export function ratioChange(current: Ratio | undefined, base: Ratio | undefined): RatioChange | undefined {
  if (current === undefined || base === undefined) return undefined
  const points = subtractRatio(current, base)
  return { direction: points.units > 0n ? 1 : points.units < 0n ? -1 : 0, points }
}

/** A change under one point reads as flat, the same band a money change uses under one percent. */
const FLAT_BAND_UNITS = 10n ** 8n

export function pointsVerdict(change: RatioChange): 'good' | 'bad' | 'flat' {
  const magnitude = change.points.units < 0n ? -change.points.units : change.points.units
  if (change.direction === 0 || magnitude < FLAT_BAND_UNITS) return 'flat'
  return change.direction > 0 ? 'good' : 'bad'
}
